/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import locale from './locale'
import Form from 'components/Form';

class ModalContent extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      formData: props.data ? {name: props.data.name} : {},
    }

    this.onChange = this.onChange.bind(this)
  }

  onChange(formData) {
    this.setState({
      formData:{
        ...this.state.formDate,
        name: formData.name
      }
    }, () => {
      this.props.onFormChange(formData)
    })
  }

  render() {
    const {formData} = this.state;
    const schema = [
      {
        name: 'name',
        label: __('Class Name', locale),
        type: 'text',
        required: true,
      },

    ];

    return (
      <div className='create-classroom-modal-content'>
        <Form
          onChange={this.onChange}
          schema={schema}
          formData={formData}
          formStyle='outline'
          getValidationRef={this.props.getValidationRef}
        />
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/CreateClassroom/ModalContent.js